import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Form } from "../../../layout";
import { Button, Input } from "../../../controls";
import { Model, UseForm } from "../../../hooks";
import { useNavigate } from "react-router-dom";

const SendFrgtCode = (props) => {
  const { forgotVal, setForgotVal, setActiveStep } = props;
  const { ForgotMdl } = Model();
  const navigate = useNavigate();
  const { values, setValues, errors, setErrors, handleInpChg } =
    UseForm(ForgotMdl);
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    let temp = {};
    temp.email = values.email !== "" ? "" : "Email is required.";
    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const submitForm = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setActiveStep(1);
      setLoading(false);
      values.forgotStep = 1;
    }
  };

  useEffect(() => {
    setValues(forgotVal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setForgotVal({ ...values });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return (
    <Form noValidate onSubmit={submitForm}>
      <Grid container className="p-[10px] pt-0" spacing={3}>
        <Grid item xs={12} className="text-center !mt-[20px] pb-[30px]">
          <h2 className="text-[22px] font-medium uppercase text-gray-500 m-0 p-[5px]">
            Forgot Password
          </h2>
          <div className="relative flex justify-center">
            <div className="border-bottom w-[60px]" />
          </div>
        </Grid>
        <Grid item xs={12} className="mb-[10px]">
          <Input
            label="Email"
            name="email"
            size="medium"
            value={values.email}
            onChange={handleInpChg}
            error={errors.email}
            className="input-primary w-full"
          />
        </Grid>
        <Grid item xs={12} className="text-center grid gap-2 mt-[10px]">
          <Button
            loading={loading}
            type="submit"
            size="large"
            className="w-full"
          >
            Send Verification Code
          </Button>
          <Button
            onClick={() => navigate("/auth")}
            variant="text"
            className="w-full"
            size="large"
          >
            Back
          </Button>
        </Grid>
      </Grid>
    </Form>
  );
};

export default SendFrgtCode;
